export const Jan2023 = [
    {
        "S. NO": "1",
        "Training Name": "Certified Information Security Manager (CISM) - Without certification",
        "Session Code": "INDBANJAN2291",
        "Batch Size": "15",
        "Start Date": "2-Jan",
        "End Date": "6-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "2",
        "Training Name": "Verbal and Written Communication skills",
        "Session Code": "INDBANJAN2290",
        "Batch Size": "15",
        "Start Date": "5-Jan",
        "End Date": "6-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "3",
        "Training Name": "Certified Ethical Hacker V12",
        "Session Code": "INDBANJAN2289",
        "Batch Size": "15",
        "Start Date": "9-Jan",
        "End Date": "13-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "4",
        "Training Name": "TOGAF 9.2 - Without certification",
        "Session Code": "INDBANJAN2280",
        "Batch Size": "15",
        "Start Date": "9-Jan",
        "End Date": "12-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "5",
        "Training Name": "EC-Council Certified Incident Handler v2",
        "Session Code": "INDBANJAN2279",
        "Batch Size": "15",
        "Start Date": "9-Jan",
        "End Date": "11-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "6",
        "Training Name": "ISO 27001:2022 Certified Lead Implementer Professional",
        "Session Code": "INDBANJAN2292",
        "Batch Size": "12",
        "Start Date": "16-Jan",
        "End Date": "20-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "7",
        "Training Name": "CCSP : Certified Cloud Security Professional - Without certification",
        "Session Code": "INDBANJAN2278",
        "Batch Size": "15",
        "Start Date": "16-Jan",
        "End Date": "20-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "8",
        "Training Name": "Devsecops",
        "Session Code": "INDBANJAN2293",
        "Batch Size": "25",
        "Start Date": "19-Jan",
        "End Date": "20-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "9",
        "Training Name": "EC Council Certified SOC Analyst (CSA)",
        "Session Code": "INDBANJAN2294",
        "Batch Size": "15",
        "Start Date": "23-Jan",
        "End Date": "25-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "10",
        "Training Name": "Security Engineering on AWS",
        "Session Code": "INDBANJAN2295",
        "Batch Size": "20",
        "Start Date": "23-Jan",
        "End Date": "25-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "11",
        "Training Name": "Basics of Business Writing",
        "Session Code": "INDBANJAN2296",
        "Batch Size": "15",
        "Start Date": "24-Jan",
        "End Date": "24-Jan",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "12",
        "Training Name": "Payment Card Industry Data Security Standard (PCI DSS)",
        "Session Code": "INDBANJAN2297",
        "Batch Size": "15",
        "Start Date": "30-Jan",
        "End Date": "31-Jan",
        "Practice": "",
        "Register": "Click Here"
    }
]